export default __webpack_public_path__ + "static/media/moon.9d452073.svg";